import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vShow as _vShow, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex justify-center items-center h-full" }
const _hoisted_2 = { class: "w-1/5" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "helpText" }
const _hoisted_5 = { class: "inputTitle" }
const _hoisted_6 = { class: "inputField flex-grow mb-4" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = { class: "error-msg" }
const _hoisted_10 = { class: "inputTitle" }
const _hoisted_11 = { class: "inputField flex-grow mb-4" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = { class: "error-msg" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = ["disabled"]
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "helpText" }
const _hoisted_18 = { class: "inputTitle" }
const _hoisted_19 = { class: "inputField flex-grow mb-4" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = { class: "error-msg" }
const _hoisted_22 = ["disabled"]

import {computed, onMounted, ref} from "vue";
import {useGuestStore} from "@/stores/GuestStore";
import router from "@/router";
import GuestService from "@/utilities/services/GuestService";
import NullOrUndefinedHelper from "@/utilities/helpers/NullOrUndefinedHelper";
import {ErrorLocationType, TicketType} from "@/utilities/enums/Enums";
import Error from "@/components/Error.vue";
import {$t} from "@/utilities/i18n/config";
import useVuelidate from "@vuelidate/core";
import {email, helpers, maxLength, minLength, requiredIf} from "@vuelidate/validators";
import {useI18n} from "vue-i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'GuestAuthorization',
  setup(__props) {

const {t} = useI18n();
const guestStore = useGuestStore();
const guestService = new GuestService();

const isValidMail = ref<boolean>(false);
const mail = ref<string|null>(null);
const otp = ref<string|null>(null);
const password = ref<string>("");

const rules = computed(() => {
  const isStaticTicket = guestStore.ticketType === TicketType.staticDownload;
  const mailWasValidated = !NullOrUndefinedHelper(mail) && guestStore.token !== null;

  return {
    mail: {
      required: helpers.withMessage(t('general.validation.required'), requiredIf(!isStaticTicket)),
      email: helpers.withMessage(t('general.validation.email'), email)
    },
    otp: {
      required: helpers.withMessage(t('general.validation.required'), requiredIf(mailWasValidated)),
      minLength: helpers.withMessage(t('general.validation.wrongLength'), minLength(6)),
      maxLength: helpers.withMessage(t('general.validation.wrongLength'), maxLength(6))
    },
    password: {
      required: helpers.withMessage(t('general.validation.required'), requiredIf(isStaticTicket))
    }
  }
})
const vuelidator = ref(useVuelidate(rules, { mail, otp, password }));

const checkDigit = (event: InputEvent) =>{
  if(isNaN(Number(event.data)))
    event.preventDefault()
}

const validateMailOrOtpOrPwd = async ()=>{
  if(!vuelidator.value.$validate()) return;

  // get token from pwd
  if(guestStore.ticketType === TicketType.staticDownload){
    const resp = await guestService.checkPwd(guestStore.ticketGuid as string, password.value as string, ErrorLocationType.guest)
    if(!resp) return;

    guestStore.token = resp;

    await router.push("/external");
    return
  }

  // validate mail, get token and show otp input
  if (guestStore.token === null){

    // validate mail and save token
    // if (mail.value && !validateEmail(mail.value.toLowerCase())) {
    //   //TODO show error message
    //   notify({
    //     title: "Error",
    //     text: $t('general.mailInvalid'),
    //     duration: -1,
    //     type: "error"
    //   });
    //   return;
    // }

    const resp = await guestService.getToken(guestStore.ticketGuid as string, mail.value as string, ErrorLocationType.guest)
    if(!resp) return;

    guestStore.token = resp;
    isValidMail.value = true;

    return;
  }


  // if (otp.value && !validateOtp(otp.value)) {
  //   //TODO show error message
  //   notify({
  //     title: "Error",
  //     text: $t('general.otpMalformed'),
  //     duration: -1,
  //     type: "error"
  //   });
  //   return;
  // }

  // validate OTP and route to actionPage
  const resp = await guestService.checkOtp(guestStore.ticketGuid as string, mail.value as string, otp.value as string, ErrorLocationType.guest)
  if(!resp) return;

  guestStore.token = resp;

  await router.push("/external");
}

onMounted(async ()=>{
  guestStore.token = null;
  guestStore.ticketGuid = router.currentRoute.value.params.id as string;
  console.log("ticket guid on Mount", guestStore.ticketGuid)
  guestStore.ticketType = await guestService.getTicketType(guestStore.ticketGuid, ErrorLocationType.guest)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Error, {
        errorLoc: _unref(ErrorLocationType).guest
      }, null, 8, ["errorLoc"]),
      (_unref(guestStore).ticketType !== _unref(TicketType).staticDownload)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(guestStore).ticketType === _unref(TicketType).download ? _unref($t)('external.auth.help.download') : _unref($t)('external.auth.help.upload')), 1),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(_unref($t)('external.auth.mail')) + " * ", 1),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", {
                  class: _normalizeClass({error: vuelidator.value.mail.$errors.length})
                }, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    placeholder: "mustermann@mail.com",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((mail).value = $event)),
                    class: "w-full",
                    disabled: isValidMail.value,
                    onKeyup: _withKeys(validateMailOrOtpOrPwd, ["enter"])
                  }, null, 40, _hoisted_7), [
                    [_vModelText, mail.value]
                  ]),
                  _hoisted_8,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(vuelidator.value.mail.$errors, (error) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "input-errors",
                      key: error.$uid
                    }, [
                      _createElementVNode("div", _hoisted_9, _toDisplayString(error.$message), 1)
                    ]))
                  }), 128))
                ], 2)
              ])
            ]),
            _withDirectives(_createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_10, _toDisplayString(_unref($t)('external.auth.otp')) + " * ", 1),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", {
                  class: _normalizeClass({error: vuelidator.value.otp.$errors.length})
                }, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    maxlength: "6",
                    placeholder: "123456",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((otp).value = $event)),
                    class: "w-full",
                    onBeforeinput: checkDigit,
                    onKeyup: _withKeys(validateMailOrOtpOrPwd, ["enter"])
                  }, null, 544), [
                    [_vModelText, otp.value]
                  ]),
                  _hoisted_12,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(vuelidator.value.otp.$errors, (error) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "input-errors",
                      key: error.$uid
                    }, [
                      _createElementVNode("div", _hoisted_13, _toDisplayString(error.$message), 1)
                    ]))
                  }), 128))
                ], 2)
              ])
            ], 512), [
              [_vShow, isValidMail.value]
            ]),
            _withDirectives(_createElementVNode("button", {
              class: "btn primary",
              disabled: _unref(NullOrUndefinedHelper)(mail.value),
              onClick: validateMailOrOtpOrPwd
            }, _toDisplayString(_unref($t)('external.auth.validateMail')), 9, _hoisted_14), [
              [_vShow, !isValidMail.value]
            ]),
            _withDirectives(_createElementVNode("button", {
              class: "btn primary",
              disabled: _unref(NullOrUndefinedHelper)(mail.value) && _unref(NullOrUndefinedHelper)(otp.value),
              onClick: validateMailOrOtpOrPwd
            }, _toDisplayString(_unref($t)('external.auth.validateOtp')), 9, _hoisted_15), [
              [_vShow, isValidMail.value]
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, _toDisplayString(_unref($t)('external.auth.help.pwd')), 1),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_18, _toDisplayString(_unref($t)('external.auth.password')) + " * ", 1),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", {
                  class: _normalizeClass({error: vuelidator.value.password.$errors.length})
                }, [
                  _withDirectives(_createElementVNode("input", {
                    type: "password",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((password).value = $event)),
                    class: "w-full",
                    onKeyup: _withKeys(validateMailOrOtpOrPwd, ["enter"])
                  }, null, 544), [
                    [_vModelText, password.value]
                  ]),
                  _hoisted_20,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(vuelidator.value.password.$errors, (error) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "input-errors",
                      key: error.$uid
                    }, [
                      _createElementVNode("div", _hoisted_21, _toDisplayString(error.$message), 1)
                    ]))
                  }), 128))
                ], 2)
              ])
            ]),
            _createElementVNode("button", {
              class: "btn primary",
              onClick: validateMailOrOtpOrPwd,
              disabled: _unref(NullOrUndefinedHelper)(password.value)
            }, _toDisplayString(_unref($t)('external.auth.validatePwd')), 9, _hoisted_22)
          ]))
    ])
  ]))
}
}

})